import React, { useEffect, useState } from "react";

import { Col, VertTypography } from "@vertem-core/vertice-ds";

import "Assets/styles/default/components/LikeMaisOnline/LikePlusCustomTerms/LikePlusCustomTerms.less";

import { cardCustomLabel, termsFile } from "Constants/LikePlus";

const LikePlusCustomTerms = () => {
  const [termsData, setTermsData] = useState([]);

  useEffect(() => {
    const loadTermsData = async () => {
      try {
        const module = await import(`./data/${termsFile}`);
        const getTermsData = module.default;

        setTermsData(getTermsData(cardCustomLabel));
      } catch (error) {
        console.error("Erro ao carregar os dados dos termos:", error);
      }
    };

    loadTermsData();
  }, []);

  return (
    <Col className="like-plus-custom-terms">
      <VertTypography.Title>Termos de uso</VertTypography.Title>

      {
        termsData.map(item => {
          if (item.title) {
            return (
              <VertTypography.Title level={3}>
                {item.title}
              </VertTypography.Title>
            );
          }

          return (
            <VertTypography.Paragraph 
              className="paragraph" 
              type="light"
            >
              {item.paragraph}
            </VertTypography.Paragraph>
          )
        })
      }
    </Col>
  );
}

export default LikePlusCustomTerms;
